import { ICategoryAsset } from "models/Assets/ICategoryAsset";

const filterSubCategoriesByMainCategory =
  (allCategories: ICategoryAsset[]) => (categoryId: number | string) : ICategoryAsset[] => {
    categoryId = Number(categoryId);
    return (
      allCategories.filter((c) => c.id === categoryId)[0]?.subCategories || []
    );
  };

export default filterSubCategoriesByMainCategory;
